import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png'

const IMg = 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=600&q=80'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const ErrorPage = (props) => {


    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header wpo-header-style-4'} Logo={Logo} />
            <PageTitle pageTitle={404} pagesub={'404'} />
            <section className="error-404-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <div className="content clearfix">
                                <div className="error">
                                    <img src={IMg} alt="" />
                                </div>
                                <div className="error-message">
                                    <h3>Oops! Page Not Found!</h3>
                                    <p>We’re sorry but we can’t seem to find the page you requested. This might be because
                                        you have typed the web address incorrectly.</p>
                                    <Link Onclick={ClickHandler} to="/" className="theme-btn-s4">Back to home</Link>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div> 
            </section>
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ErrorPage;



